import Accordion from '@components/Accordion';
import Column from '@components/Column';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

function AccountManagement() {
    const { t } = useTranslation('accountSetting');
    return (
        <Accordion title={t('accountManagement.title')}>
            <Contents spacing={6} >
            </Contents>
        </Accordion>
    );
}

const Contents = styled(Column)`
    padding: 12px 0 20px;
`;

export default AccountManagement;
